// extracted by mini-css-extract-plugin
export default {"copy":"Link-module--copy--909de","check":"Link-module--check--2758e"};